import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import "./style.css";

export const PRIMARY_ACTION_VARIANTS = Object.freeze({
  PRIMARY: "primary",
  WARNING: "warning",
});

const AppModal = ({
  visibility,
  handleClose,
  title,
  description,
  primaryLabel,
  secondaryLabel,
  onPrimaryAction,
  onSecondaryAction,
  loading,
  disablePrimaryAction,
  actionType = PRIMARY_ACTION_VARIANTS.PRIMARY,
  showActionButtons = true,
  modalClasses = "",
  children,
  keepMounted
}) => {
  const computedModalClassName = `app-modal ${typeof modalClasses === "string" ? modalClasses : ""}`;

  return (
    <Dialog
      className={computedModalClassName}
      open={visibility}
      onClose={handleClose}
      keepMounted={keepMounted}
    >
      <Grid
        container
        className="app-modal-header"
        justifyContent="space-between"
      >
        <Typography variant="body1" className="title-txt">
          {title}
        </Typography>
        <CloseIcon
          onClick={handleClose}
          className="cursor-pointer"
          style={{ color: "#fff" }}
        />
      </Grid>
      <Divider />
      <DialogContent>
        <Grid container direction="column">
          {description && (
            <Typography className="pb-16">{description}</Typography>
          )}
          {children}
        </Grid>
      </DialogContent>
      {showActionButtons && (
        <DialogActions>
          <Grid container justifyContent="flex-end" className="gap-x-8 px-16">
            <Button variant="outlined" onClick={onSecondaryAction}>
              {secondaryLabel ?? "Cancel"}
            </Button>
            <Button
              variant="contained"
              disabled={disablePrimaryAction}
              onClick={onPrimaryAction}
              className={`app-modal-action-btn-${actionType}`}
            >
              {loading ? (
                <CircularProgress size={15} style={{ color: "#fff" }} />
              ) : (
                <Typography variant="body2" className="primary-btn-label">
                  {primaryLabel ?? "Save"}
                </Typography>
              )}
            </Button>
          </Grid>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default AppModal;
